module.exports = __webpack_public_path__ + "img/ai_generate.1266fe04.svg";